<template>
  <div class="access">

    <el-row type="flex" justify="center">
      <el-col :md="20" :lg="18" :xl="15">
        <el-row>
          <el-col :span="12">
            <iframe :title="t.mapTitle" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1620.7302022458769!2d139.77382708041415!3d35.66566389811144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601889623b873a13%3A0x1c21f5e80c1e7f9d!2z44CSMTA0LTAwNDUg5p2x5Lqs6YO95Lit5aSu5Yy656-J5Zyw77yX5LiB55uu77yR77yR4oiS77yVIOS4remKgOODmeODq-evieWcsOODnuODs-OCt-OCquODsyAy6ZqO!5e0!3m2!1sja!2sjp!4v1633341603803!5m2!1sja!2sjp" width="100%" height="480" style="border:none" allowfullscreen="" loading="lazy"></iframe>
          </el-col>
          <el-col :span="11">
            <div class="schedule">
              <div class="name">
                <div class="name-tenyukai">{{ t.corp }}</div>
                <div class="name-nozomi">{{ t.name }}</div>
              </div>
              <div class="address">
                <div v-for="(a, i) in t.address" :key="i">{{ a }}</div>
              </div>
              <div class="tel">
                <div><img src="../../assets/icon/icon_tel_hover_28x28@2x.png" alt="" width="28" height="28"></div>
                <div class="tel-number">03-6260-6008</div>
              </div>
              <div class="table" :class="{ en: $lang === 'en' }">
                <table>
                  <tr>
                    <td>{{ t.hours }}</td>
                    <td v-for="d in t.days" :key="d">{{ d }}</td>
                  </tr>
                  <tr v-for="slot in ['10:00 ～ 13:30', '14:30 ～ 19:00']" :key="slot">
                    <td>{{ slot }}</td>
                    <td v-for="(o, i) in open" :key="i">{{ o ? '〇' : t.off }}</td>
                  </tr>
                </table>
              </div>
              <div class="notice">{{ t.n1 }}</div>
              <div class="notice">{{ t.n2 }}</div>
              <!-- <div class="notice">※ 火曜、木曜臨時内装工事による、臨時休診にします。診療日再開予定しております。</div> -->
              <!-- <div class="notice">※ 月曜は、白川　太郎先生による「がんの自由診療」のみ実施しております。</div> -->
              <div class="notice">{{ t.n3 }}</div>
              <!-- <div class="notice">※ 10月21日（火）から11月30日（日）まで、院内改装のため、対面での診療を一時休止いたします。期間中は、オンライン遠隔診療のみご利用いただけます。</div> -->
              <div class="notice">{{ t.n4 }}</div>

              <div v-if="showButtons" class="info">
                <div class="btn-line" @click="goHref('https://lin.ee/AqbMjHK')">
                  <div class="btn-icon"></div>
                  <div class="btn-text">
                    <div>{{ t.line }}</div>
                    <div class="sub-text">{{ t.lineSub }}</div>
                  </div>
                </div>
                <div class="btn-online" @click="goHref('https://connect.kireipass.jp/clinics/tenyukai-hope/web-order/menus')">
                  <div class="btn-icon"></div>
                  <div class="btn-text">
                    <div>{{ t.web }}</div>
                    <!-- <div class="sub-text">オンライン診療はこちらから</div> -->
                    <div class="sub-text">{{ t.webSub }}</div>
                  </div>
                </div>
                <div class="btn-mail" @click="goTo('/sending')">
                  <div class="btn-icon"></div>
                  <div class="btn-text">{{ t.contact }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

      </el-col>
    </el-row>

  </div>
</template>

<script>
import ACCESS_T from '@/i18n/access'

export default {
  name: "HomeAccess",
  data() {
    return { open: [true, true, false, true, true, true, false] }
  },
  computed: {
    t() { return ACCESS_T[this.$lang] || ACCESS_T.ja },
  },
  props: {
    // 下部の LINE予約／WEB予約／お問合せ ボタンを表示するか
    showButtons: { type: Boolean, default: true },
  },
  methods: {
    goTo(page) {
      this.$router.push(this.$lp(`${page}`))
    },
    goHref(path) {
      window.location.href = path;
    }
  }
}
</script>

<style scoped>
/*病院情報*/
.access {
  margin: 60px 0;
}
.schedule {
  width: 100%;
  margin-left: 30px;
}
.schedule .name-tenyukai {
  color: #9E9E9E;
  font-size: 14px;
  font-weight: bold;
}
.schedule .name-nozomi {
  color: #62B6E2;
  font-size: 20px;
  font-weight: bold;
}
.schedule .address {
  font-size: 14px;
  margin-top: 14px;
}
.schedule .tel {
  align-items: center;
  display: flex;
  margin-top: 14px;
}
.schedule .tel .tel-number {
  font-size: 24px;
  font-weight: bold;
  margin-left: 14px;
}
/*診療時間*/
.schedule .table table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 16px;
  margin-top: 10px;
  width: 100%;
}
.schedule .table table tr:first-child {
  background-color: #f0f0f0;
}
.schedule .table table td {
  border: 1px solid #cccccc;
  text-align: center;
  padding: 16px;
}
/* 英語は曜日（Mon など）が長いので、左右の余白を詰めて枠内に収める */
.schedule .table.en table td {
  padding: 16px 6px;
}
.schedule .notice {
  font-size: 12px;
  margin-top: 12px;
  margin-left: 12px;
}
/*予約・お問い合わせ*/
.info {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap; /* 英語などで幅が足りないときは折り返す */
  row-gap: 12px;
}
.info .btn-line {
  align-items: center;
  background-color: #62B6E2;
  color: #ffffff;
  border: 2px solid #62B6E2;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  padding: 12px 20px;
  transition: 150ms;
}
.info .btn-line .btn-icon{
  height: 36px;
  width: 36px;
  background-image: url("../../assets/icon/icon_calendar_36x36@2x.png");
  background-size: 100%;
  transition: 150ms;
}
.info .btn-line:hover {
  background-color: #FFFFFF;
  color: #62B6E2;
}
.info .btn-line:hover .btn-icon{
  background-image: url("../../assets/icon/icon_calendar_hover_36x36@2x.png");
}
.info .btn-online {
  align-items: center;
  background-color: #62B6E2;
  color: #ffffff;
  border: 2px solid #62B6E2;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  padding: 12px 20px;
  margin-left: 20px;
  transition: 150ms;
}
.info .btn-online .btn-icon{
  height: 36px;
  width: 36px;
  background-image: url("../../assets/icon/icon_calendar_36x36@2x.png");
  background-size: 100%;
  transition: 150ms;
}
.info .btn-online:hover {
  background-color: #FFFFFF;
  color: #62B6E2;
}
.info .btn-online:hover .btn-icon{
  background-image: url("../../assets/icon/icon_calendar_hover_36x36@2x.png");
}
.info .btn-mail {
  align-items: center;
  background-color: #62B6E2;
  color: #ffffff;
  border: 2px solid #62B6E2;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  padding: 12px 20px;
  margin-left: 20px;
  transition: 150ms;
}
.info .btn-mail .btn-icon{
  height: 36px;
  width: 36px;
  background-image: url("../../assets/icon/icon_mail_36x36@2x.png");
  background-size: 100%;
  transition: 150ms;
}
.info .btn-mail:hover {
  background-color: #ffffff;
  color: #62B6E2;
}
.info .btn-mail:hover .btn-icon{
  background-image: url("../../assets/icon/icon_mail_hover_36x36@2x.png");
}
.info .btn-text {
  font-size: 16px;
  margin-left: 10px;
}
.info .btn-text .sub-text {
  font-size: 12px;
  margin-top: 4px;
}
</style>
